module.exports = __webpack_public_path__ + "img/3.cb2841c1.png";